<div class="header">
  <div class="nav-wrapper">
    <div class="school-wrapper">
      <div class="image-wrapper">
        <img
          [src]="schoolLogo ? schoolLogo : '../assets/images/school-logo.svg'"
          alt="logo"
        />
      </div>
      <h1 class="school-name">
        {{ schoolName }}
      </h1>
    </div>
    <div class="links-wrapper">
      <ul class="nav-links">
        <li (click)="scrollToSection('director-desk')">Principal's desk</li>
        <li (click)="scrollToSection('about-us')">About Us</li>
        <li (click)="scrollToSection('faacilities')">Facilities</li>
        <!-- <li (click)="openShareDialog()">Share</li> -->
        <!-- <li (click)="scrollToSection('sports')">Sports</li> -->
        <li (click)="openDownloadDialog()">Downloads</li>
      </ul>
      <div class="btn-wrapper">
        <button class="button" color="primary" (click)="openFormDialog()">
          Admission Enquiry
        </button>
      </div>
      <app-form
        *ngIf="isFormVisible"
        [title]="formTitle"
        [submitButtonLabel]="formSubmitButtonLabel"
        [isEducationLevelRequired]="isEducationLevelRequired"
        (submitForm)="handleFormSubmission($event)"
      ></app-form>
    </div>
    <div class="links-mobile" *ngIf="isMobile">
      <div class="menu-wrap" (click)="toggleMenu()">
        <img src="../assets/images/menuLogo.png" alt="menu-logo" />
      </div>
      <div class="side-menu" [class.open]="menuOpen" (click)="closeMenu()">
        <div class="close-icon" (click)="toggleMenu($event)">&#10005;</div>
        <ul class="nav-links">
          <li (click)="scrollToSection('director-desk')">Principal's desk</li>
          <li (click)="scrollToSection('about-us')">About Us</li>
          <li (click)="scrollToSection('faacilities')">Facilities</li>
          <!-- <li (click)="scrollToSection('sports')">Sports</li> -->
          <!-- <li (click)="openShareDialog()">Share</li> -->
          <li (click)="openDownloadDialog()">Downloads</li>
        </ul>
        <div class="btn-wrapper">
          <button class="button" color="primary" (click)="openFormDialog()">
            Admission Enquiry
          </button>
          <!-- <button
            class="share"
            color="primary"
            href="https://app.inforida.com"
            (click)="openShareDialog()"
          >
            Share
          </button> -->
        </div>
        <app-form
          *ngIf="isFormVisible"
          [title]="formTitle"
          [submitButtonLabel]="formSubmitButtonLabel"
          [isEducationLevelRequired]="isEducationLevelRequired"
          (submitForm)="handleFormSubmission($event)"
        ></app-form>
      </div>
    </div>
  </div>
</div>
